exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-05975ad8],th[data-v-05975ad8]{width:220px;max-width:220px;min-width:220px}[data-v-05975ad8] .v-datatable.v-table>tbody{max-height:13vh;min-height:13vh}", ""]);

// exports
